export const ABOUT_DISCIPLINES = [
  'Creative Direction & AI',
  '3D & Visual Production',
  'Information Design',
  'Web Development',
];

export const ABOUT_FACTS = [
  { label: 'Practice', value: 'Independent · Since 2019' },
  { label: 'Approach', value: 'Direct & hands-on' },
];

export const ABOUT_CERTIFICATIONS = [
  'Google AI Professional',
  'Autodesk Maya',
  'IT Specialist (AI & Python)',
  'Meta Certified',
  'Google Ads',
];

export const ABOUT_CLIENTS = [
  'Menya',
  'Psyop Studio',
  'Varsha Studios',
  'Norwegian CS',
  'IBM',
  'KLM',
  "Histoire d'Or",
  "Dior",
  'Douglas',
  'UENI Mktg',
  'Eurotrip',
  'Mismo',
  'Mescalina',
];
